export default {
  hoverColour: 'brandOne100',
  backgroundColor: 'brandOne100',
};
